import React, { Component } from "react";
import Header from "../Header/Header";
import Translator from "../../components/Translator";
import { Redirect } from "react-router";
import * as Sentry from "@sentry/browser";

class Keycard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
        };

        setTimeout(() => {
            this.setState({ redirect: true });
        }, 80000);
        this.handleOK = this.handleOK.bind(this);
    }

    handleOK(event) {
        this.setState({ redirect: true });
    }

    componentDidMount = () => {
        Sentry.captureEvent({
            level: "info",
            message: "Reservation " + (this.props.reservation?.id ?? "-") + " Checkin completed: keycard",
        });
    };

    render() {
        if (this.state.redirect) {
            return <Redirect refresh={true} to="/main/thankyou" />;
        }

        const printerBroken = localStorage.getItem("printerBroken") === "true";
        if (printerBroken) {
            return <Redirect refresh={true} to="/main/thankyou" />;
        }

        let roomNumber = "###";
        if (this.props.location.state?.roomNumber) {
            roomNumber = this.props.location.state.roomNumber;
        }

        let cardCount = 1;
        if (this.props.location.state?.cardCount) {
            cardCount = this.props.location.state.cardCount;
        }

        let hotlineNumber = <Translator content={"help.number"} />;

        const localStorageHotline = localStorage.getItem("hotline");
        if (localStorageHotline && localStorageHotline !== "") {
            hotlineNumber = <span>{localStorageHotline}</span>;
        }
        return (
            <div className="page-keycard">
                <div className="page-inner-wrapper">
                    <Header headerTitle="pageTitles.keycardPage" />
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col-6">
                                <div className="bodytext-app __number-wrap">
                                    <strong className="__number">{roomNumber}</strong>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="bodytext-app">
                                    <h2 className="h2-heading __title">
                                        <Translator content={this.buildTitle(cardCount)} />
                                    </h2>
                                    <div className="__description">
                                        <Translator content={this.buildDescription(cardCount)} />
                                    </div>

                                    <h2 className="h2-heading __hotline">{hotlineNumber}</h2>
                                    <button
                                        onClick={this.handleOK}
                                        className="btn btn-stayery-black btn-uppercase btn-fullwidth btn-space"
                                    >
                                        <Translator content={"keycard.button"} />{" "}
                                        <i className="icon icon-stayery-arrow-r" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildTitle(cardCount) {
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
        const baseKey = manuelCardWorkflow ? "keycard.manual." : "keycard.general.";

        return cardCount === 1 ? `${baseKey}title` : `${baseKey}title_2`;
    }

    buildDescription(cardCount) {
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
        const baseKey = manuelCardWorkflow ? "keycard.manual." : "keycard.general.";

        return cardCount === 1 ? `${baseKey}checkinDescription` : `${baseKey}checkinDescription_2`;
    }
}

export default Keycard;
